export const CONTACT_US_URL = 'https://share.hsforms.com/195eHKT2fQOGQD84W2gSmUg4rhvg';

export const statuses = {
  ACCEPTED: 'ACCEPTED',
  ERRORS: 'ERRORS',
  REJECTED: 'REJECTED',
};

export const READ_ONLY_LABEL = ' - (read only mode)';
